<template>
  <div>
    <div class="font-bold mb-3">
      <p>{{ $i18nPresenter.t('Download report') }}</p>
    </div>
    <div class="flex gap-3">
      <div class=" card-section" :class="{'disable-card': loadingExportExcelV2}">
        <IconNeedUpgradePlanV2
          v-if="isPlanFree"
          :text="$i18nPresenter.t('This feature is not available in your current plan.')"
          :buttonText="$i18nPresenter.t('Upgrade')"
          class="cursor-pointer absolute inset-0"
          classIcon="absolute top-1 right-1"
          @openPlanUpgradeModal="openPlanUpgradeModal"
        />
        <div
          class="badge-option relative flex justify-center align-middle"
          @click="handleExport('excel')"

          :class="{'pointer-events-none': isPlanFree }"
        >
          <img src="@/assets/images/icon/excel-icon.svg" alt="" v-if="!loadingExportExcelV2">
          <aha-spinner v-else />
          Excel
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExportSection from '@/components-v2/presentation-report/ExportSection.vue'
import IconNeedUpgradePlanV2 from '@/components-v2/my-plan/IconNeedUpgradePlanV2.vue'
import DownloadSlideSection from '@/components-v2/editor-share-v2/DownloadSlideSection.vue'

export default {
  name: 'DownloadReportSection',
  components: {
    IconNeedUpgradePlanV2,
  },
  extends: ExportSection,
  data() {
    return {
      skipParentMounted: true,
      skipParentDestroyed: true,
    }
  },
  methods: {
    openPlanUpgradeModal: DownloadSlideSection.methods.openPlanUpgradeModal,
  },
}
</script>

  <style scoped lang="scss">
  .side-center-modal-share-slide {
    .side-center_title {
      font-size: 14px;
      line-height: 18px;
    //letter-spacing: 0rem;
      text-align: left;
      margin-bottom: 12px;
    }
  }
  p{
    color : #282E3E;
  }
  .card-section{
    position: relative;
    border-radius: 4px;
    border: 1px solid #EBEBEB; /* Set the default border */
    &:hover{
      background: #ECF4FE;
      border-color: #348EF6;
    }
  }

  .disable-card {
    opacity: 0.5;
    pointer-events: none;
    &:hover{
      background: none;
    }
  }
  .badge-option {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px;
    gap: 4px;
    border-radius: 4px;
    width: 108px;
    height: 68px;
    color:#282E3E;
  }
  </style>
